import {useEffect, useRef, useState} from "react";
import {appArray} from "../../App";


interface IModalFactoryType {
    id: string;
    title: string;
    icon: string;
    isOpen: boolean;
    setOpen: (isOpen: boolean) => void;
    isOnTop: boolean;
    setOnTop: (isOnTop: boolean) => void;
    instance: JSX.Element;
}

class ModalFactory {
    private static modals: IModalFactoryType[] = [];


    public static init(): IModalFactoryType[] {
        this.modals = [];

        appArray.forEach((app) => {
            const [isOpen, setOpen] = useState(false);
            const [isOnTop, setOnTop] = useState(false);
            let rootRef = useRef<HTMLDivElement>(null);

            this.modals.push({
                id: app.id,
                title: app.name,
                icon: app.icon,
                isOpen: isOpen,
                setOpen: setOpen,
                isOnTop: isOnTop,
                setOnTop: setOnTop,
                instance: (
                    <div
                        style={{display: isOpen ? "block" : "none", zIndex: isOnTop ? 200 : 100 }}
                        ref={rootRef}
                    >
                        {app.component}
                    </div>
                ),
            })
        })

        return this.modals;
    }

    public static getModal(id: string): IModalFactoryType {
        if (this.modals.length === 0) {
            this.init();
        } if (this.modals.length > 0) {
            return this.modals.find((modal) => modal.id === id) as IModalFactoryType;
        } else {
            throw new Error("No modals found");
        }
    }

    static openModal(id: string) {
        const modal = this.getModal(id);
        modal.setOpen(true);
    }

    static closeModal(id: string) {
        const modal = this.getModal(id);
        modal.setOpen(false);
    }

    static toggleModal(id: string) {
        const modal = this.getModal(id);
        modal.setOpen(!modal.isOpen);
    }

    static setModalOnTop(id: string) {
        // Set the modal on top and set all other modals to not be on top
        const modal = this.getModal(id);
        modal.setOnTop(true);
    }
}



export default ModalFactory;
